// Overridable WebSocket implementation. Defaults to the platform WebSocket;
// main.tsx swaps in the mock implementation when config.USE_MOCKS is true.
// Keeping this indirection out of ws.ts avoids importing the mock dataset in
// production builds.

let impl: typeof WebSocket | undefined =
  typeof WebSocket !== 'undefined' ? WebSocket : undefined;

export function setWebSocketImpl(next: typeof WebSocket): void {
  impl = next;
}

export function getWebSocketImpl(): typeof WebSocket | undefined {
  return impl;
}
